export default __webpack_public_path__ + "static/media/icon_urheilutoiminta_lukittu.1c614a72.svg";